<template>
  <div id="ProjectDetails">
    <template v-if="!emptyShow">
      <div class="project-column" v-for="(column,i) in data.columns" :key="i">
        <div class="project-column-title" @click="togglehHandle(i,closeIndex===i)" :class="{'close':closeIndex===i}">
          <h4>{{ column.columnName }}</h4>
          <span>
            <van-icon class="iconfont" class-prefix="icon" name="enterinto"></van-icon>
          </span>
        </div>
        <div class="project-column-content" :class="{'close':closeIndex===i}">
          <van-row>
            <van-col span="12" v-for="(service,index) in column.columnService" :key="index">
              <div class="item y-center" @click="goDetail(service)">
                <span>
                  <img
                      :src="complete(service.icon)"
                      onload="SVGInject(this)"
                      round
                      fit="cover"/>
                </span>
                <p>{{ service.name }}</p>
              </div>
            </van-col>
          </van-row>
        </div>
      </div>
    </template>
    <template v-else>
      <Error :type="'empty'"></Error>
    </template>
  </div>
</template>
<script>
import {querySpeciaList} from "@/api/project";
import {Toast} from 'vant'
import * as svg from '@/utils/svg-inject.min'
import {complete} from "@/utils/url";
import {mapState} from "vuex";
import {querySpeciaService} from "@/api/home";

export default {
  name: 'ProjectDetails',
  props:['id'],
  data(){
    return {
      closeIndex:false,
      data:{},
      emptyShow: false,
    }
  },
  computed: {
    //...mapState(['speciaColumns'])
  },
  created() {
    querySpeciaService({id:this.id}).then(resp=>{
      if (resp.code && resp.code == 200) {
        if (resp.data.speciaName) {
          document.title = resp.data.speciaName;
        }
        this.data = resp.data;
        if (this.data.columns.length > 0) {
          this.emptyShow = false;
        } else {
          this.emptyShow = true;
        }
      }
    })
  },
  methods: {
    togglehHandle(i,close){
      this.closeIndex = close||i;
    },
    goDetail(item) {
      this.$router.push('/serviceHall/detail/' + item.id);
    },
    complete
  }
}
</script>
<style scoped lang="scss">
@import "../../assets/css/theme/theme";

.project-column {
  padding: 15px 9px;
  .project-column-title {
    height: 24px;
    padding: 0 6px;
    margin-bottom: 15px;
    h4 {
      float: left;
      line-height: 24px;
      color: $c333;
      @extend .font18;
    }
    &.close{
      span{
        transform: rotate(-270deg) !important;
      }
    }
    span {
      float: left;
      display: block;
      width: 24px;
      height: 24px;
      margin-left: 5px;
      transform: rotate(-90deg);
      i {
        display: block;
        width: 100%;
        height: 100%;
        font-size: 24px;
        color: $c333;
      }
    }
  }

  .project-column-content {
    &.close{
      display: none;
    }
    .item {
      position: relative;
      height: 75px;
      padding: 15px;
      margin: 6px;
      box-sizing: border-box;
      border-radius: 6px;
      background: #fff;

      span {
        position: absolute;
        left: 15px;
        top: 50%;
        z-index: 999;
        display: block;
        width: 26px;
        height: 26px;
        margin-top: -13px;

        img,
        svg {
          display: block;
          width: 100%;
          height: 100%;
          fill: var(--main-color);
        }
      }

      p {
        max-height: 52px;
        padding-left: 35px;
        line-height: 26px;
        color: $c333;
        display: -webkit-box;
        -webkit-box-orient: vertical;
        -webkit-line-clamp: 2;
        overflow: hidden;
        @extend .font18;
      }
    }
  }
}
.empty{
  margin-top: 100px;
}
</style>
